import useSWR from './useSWR'

/* workaround for react hooks problem with different number of hooks for each render */

const pageLimit = 20

const useSwrPagination = (swrKey, pageQty, query, config) => {
  const fullData = []
  let isValidating = false

  for (let page = 0; page < pageLimit; page++) {
    const formattedQuery = { ...query }
    if (query.oldestIds && page > 0) {
      formattedQuery.oldestId = query.oldestIds[page - 1]
    }
    delete formattedQuery.oldestIds
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const hook = useSWR(page < pageQty && swrKey, { page, ...formattedQuery }, config)
    fullData.push(hook.data)
    if (hook.isValidating) isValidating = true
  }

  return { data: fullData.flat().filter((d) => d), isValidating }
}

export default useSwrPagination
